import { render, staticRenderFns } from "./tabs_video.vue?vue&type=template&id=2fa8b90f"
import script from "./tabs_video.vue?vue&type=script&lang=ts"
export * from "./tabs_video.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports